import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';

export interface SupportTicketSubmission {
  audience: 'kunde' | 'handwerker' | 'anonymous';
  topic: string;
  body: string;
  name: string;
  emailFrom: string;
  bookingId?: string | null;
  consentDataPrivacy: boolean;
  honeypot: string;
  attachment?: File | null;
}

export interface SupportTicketResponse {
  ticketId: string;
  createdAt: string;
}

@Injectable({ providedIn: 'root' })
export class SupportService {
  private readonly http = inject(HttpClient);

  async createTicket(input: SupportTicketSubmission): Promise<SupportTicketResponse> {
    const fd = new FormData();
    fd.append('audience', input.audience);
    fd.append('topic', input.topic);
    fd.append('body', input.body);
    fd.append('name', input.name);
    fd.append('emailFrom', input.emailFrom);
    if (input.bookingId) fd.append('bookingId', input.bookingId);
    fd.append('consentDataPrivacy', String(input.consentDataPrivacy));
    fd.append('website', input.honeypot ?? '');
    if (input.attachment) fd.append('attachment', input.attachment);

    return firstValueFrom(
      this.http.post<SupportTicketResponse>('/api/support/ticket', fd),
    );
  }
}
